var React = require('react');

function Reporting (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 10H10V0L0 10Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 35V14.0001H10C12.2091 14.0001 14 12.2093 14 10.0001V0.000116825V0H29C31.7614 0 34 2.23858 34 5V35C34 37.7614 31.7614 40 29 40H5C2.23858 40 0 37.7614 0 35ZM10 0.000116825L0 10.0001H10V0.000116825ZM6 22C6 20.8954 6.89543 20 8 20H26C27.1046 20 28 20.8954 28 22C28 23.1046 27.1046 24 26 24H8C6.89543 24 6 23.1046 6 22ZM6 30C6 28.8954 6.89543 28 8 28H26C27.1046 28 28 28.8954 28 30C28 31.1046 27.1046 32 26 32H8C6.89543 32 6 31.1046 6 30Z","key":1})]);
}

Reporting.defaultProps = {"width":"34","height":"40","viewBox":"0 0 34 40","fill":"currentColor"};

module.exports = Reporting;

Reporting.default = Reporting;
